export default "<app-mat-tree type=\"claim\" listName=\"claims\"></app-mat-tree>\n<router-outlet></router-outlet>";